// extracted by mini-css-extract-plugin
export default {"wrapper":"color_badge-module___wrapper___b0baa390","colorBadge":"color_badge-module___colorBadge___d2e10beb","buttonStyle":"color_badge-module___buttonStyle___adf2cd2b"};